var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeButton = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

exports.ThemeButton = function (props) {
  if (props.hideThemeButton) {
    return null;
  }

  return react_1.default.createElement(core_1.Button, {
    ariaLabel: "Current theme is " + props.buttonName,
    onClick: function onClick() {
      return props.toggleTheme();
    },
    title: "Current theme is " + props.buttonName,
    type: "button",
    value: "",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style
    })
  }, props.buttonName);
};